import { IAccount, IUpdateAccountBillingSettingsRequestDto, IUpdateGearbeltBillingSettingsRequestDto } from '@site-mate/sitemate-global-shared';

import { GlobalApiClient } from './global-api.client';

async function getAccountById(accountId: string): Promise<IAccount | null> {
  const res = await GlobalApiClient.get(`/accounts/${accountId}`);

  if (res.status === 200) {
    return res.data;
  } else {
    return null;
  }
}

async function updateAccount(form: Pick<IAccount, '_id'> & Pick<Partial<IAccount>, 'name' | 'ssoEnabled'>): Promise<IAccount | null> {
  const { _id: accountId, ...body } = form;
  const res = await GlobalApiClient.patch(`/accounts/${accountId}`, body);

  if (res.status === 200) {
    return res.data;
  } else {
    return null;
  }
}

type IUpdateAccountBillingSettingsForm = Pick<IAccount, '_id' | 'accountType' | 'automatedBilling'> & { billing: IUpdateAccountBillingSettingsRequestDto };
async function updateAccountBillingSettings(form: IUpdateAccountBillingSettingsForm) {
  const { _id: accountId, accountType, automatedBilling, billing: accountBillingSettings } = form;
  await GlobalApiClient.patch(`/accounts/${accountId}`, {
    accountType,
    automatedBilling,
  });
  await GlobalApiClient.patch(`/accounts/${accountId}/billing`, accountBillingSettings);
}

async function updateGearbeltBillingSettings({ accountId, ...form }: IUpdateGearbeltBillingSettingsRequestDto & { accountId: string }) {
  await GlobalApiClient.patch(`/accounts/${accountId}/billing/gearbelt`, form);
}

async function enableAccountLayer(accountId: string): Promise<void> {
  await GlobalApiClient.patch(`/accounts/${accountId}/billing`, { isAccountLayerEnabled: true });
}

async function validateSubdomain(subdomain: string) {
  const res = await GlobalApiClient.get(`/accounts/validate/subdomain`, {
    params: {
      subdomain,
    },
  });
  return res.data;
}

export const accountService = {
  getAccountById,
  updateAccount,
  updateAccountBillingSettings,
  updateGearbeltBillingSettings,
  enableAccountLayer,
  validateSubdomain,
};
